import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20fluid%20organic%20composition%20with%20flowing%20coral%20peach%20and%20warm%20sand%20shapes%2C%20soft%20gradient%20transitions%20between%20terracotta%20cream%20and%20olive%20sage%20tones%2C%20floating%20geometric%20blobs%20with%20gentle%20shadows%2C%20Scandinavian%20modern%20art%20aesthetic%2C%20light%20airy%20atmosphere%20with%20subtle%20texture%2C%20editorial%20design%20background%20with%20generous%20negative%20space%2C%20harmonious%20warm%20palette%2C%20no%20sharp%20edges&width=1800&height=900&seq=yoybuy-hero-bg-v2&orientation=landscape"
          alt="YOYBUY Spreadsheet background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-50/70 via-background-50/50 to-background-50/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 flex flex-col items-start text-left lg:pt-10">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-foreground-900 leading-tight tracking-tight">
              {t('hero.title_1')}{' '}
              <span className="italic text-accent-500">{t('hero.title_2')}</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg">
              {t('hero.subtitle')}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
              >
                <span>{t('hero.cta_sheet')}</span>
                <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-800 text-sm font-semibold hover:border-foreground-900 hover:text-foreground-900 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
              >
                <span>{t('hero.cta_buy')}</span>
                <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Lifestyle%20flatlay%20composition%20featuring%20premium%20sneakers%20beside%20leather%20watch%20and%20minimalist%20sunglasses%20on%20textured%20linen%20fabric%2C%20warm%20afternoon%20sunlight%20streaming%20diagonally%20across%20arrangement%2C%20curated%20personal%20style%20aesthetic%2C%20soft%20natural%20shadows%2C%20sophisticated%20casual%20elegance%2C%20warm%20amber%20and%20sand%20tones%2C%20editorial%20fashion%20catalogue%20photography&width=900&height=700&seq=yoybuy-hero-product-v2&orientation=landscape"
                alt="YOYBUY Spreadsheet products"
                className="w-full h-auto rounded-3xl object-cover"
              />
              <div className="absolute -bottom-4 -right-4 bg-accent-500 text-background-50 px-5 py-2.5 rounded-2xl text-sm font-semibold whitespace-nowrap">
                14+ категорий
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}